import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.CustomPricePoint.Save.IRequest;
type Response = Api.Core.CustomPricePoint.Save.IResponse;
type Headers = Api.Core.CustomPricePoint.Save.IHeaders;
const url = '/api/ProductManagement/CustomPricePoint';
export default async function customPricePointSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
